/**
 * O vocabulário de estado do Caso.
 *
 * Voltou para dentro de `features/casos` quando o quadro virou uma VISÃO desta
 * feature em vez de uma feature própria: a razão de ele estar em `shared/` era
 * o `eslint-plugin-boundaries` barrando feature importando de feature, e essa
 * fronteira deixou de ser atravessada.
 */

import type { CaseState } from '@anery/api-contracts';

/**
 * Estado do caso, no vocabulário do FIO.
 *
 * Fica em inglês de propósito: é o token que trafega, e foi decisão de
 * arquitetura. Traduzir cedo demais faria o front comparar `'Autorizado'`
 * com o que a API mandou e errar em silêncio.
 */
export type EstadoDoCaso = CaseState;

/**
 * `EstadoDoCaso` → o que a pessoa lê.
 *
 * `Record<EstadoDoCaso, string>` não é enfeite de tipo: se a API ganhar um
 * oitavo estado, a próxima geração do contrato quebra ESTE objeto no `tsc`,
 * que é onde a quebra custa menos. Sem ele, o estado novo chegaria à tela
 * como célula vazia.
 */
export const ROTULOS_DE_ESTADO: Record<EstadoDoCaso, string> = {
  Received: 'Recebido',
  UnderAssessment: 'Em avaliação',
  QuoteIssued: 'Orçamento emitido',
  AwaitingPayer: 'Aguardando operadora',
  Authorized: 'Autorizado',
  Declined: 'Recusado',
  Closed: 'Encerrado',
};

/**
 * Os 7 estados, em runtime.
 *
 * Derivado do `Record` acima justamente para não existir uma segunda lista
 * que alguém esqueça de atualizar — é a mesma ideia do `VocabularySyncTests`
 * do backend, em escala de um arquivo.
 */
export const ESTADOS_DO_CASO = Object.keys(ROTULOS_DE_ESTADO) as readonly EstadoDoCaso[];

export function ehEstadoDoCaso(valor: unknown): valor is EstadoDoCaso {
  return typeof valor === 'string' && Object.hasOwn(ROTULOS_DE_ESTADO, valor);
}
